
import React from 'react';
import BusRatesTable from './BusRatesTable';
import LuxuryCarRatesTable from './LuxuryCarRatesTable';

const Packages = () => {

 
  return (
   <div>
 

   <section
      className="page-title"
      style={{ backgroundImage: 'url(images/background/3.jpg)' }}
    >
      <div className="auto-container">
        <h1> Packages</h1>
        <div className="bread-crumb-outer">
         
        </div>
      </div>
    </section>




    {/* <CabRatesTable/> */}
<BusRatesTable/>
<LuxuryCarRatesTable/>
<div className="rules-guidelines-container">
  <h2 className="rules-title">General Terms & Conditions</h2>
  <ul className="rules-list">
    <li>Kms & time calculate from garage to garage.</li>
    <li>Rates offered will be valid for a period of one year. However, rates will be revised due to hike in fuel charges. Today Diesel Rate: ₹96.00/Ltr</li>
    <li>Toll & parking charges at actual extra.</li>
    <li>For outstation duty, minimum charged km per day is 300 kms.</li>
    <li>Payment within 20 days from the date of submission of bill.</li>
    <li>Time & days calculated as per calendar day.</li>
    <li>GST will be extra as applicable.</li>
    <li>Driver allowance will be applicable for outstation use.</li>
  </ul>
</div>



   </div>
  );
};

export default Packages;
